// constants/notificationRulesByRole.js

export const NOTIFICATION_RULE_CATEGORIES = {
  FINANCIAL: 'financial',
  OPERATIONAL: 'operational',
  TEAM: 'team'
};

export const getNotificationRulesByRole = (userRole) => {
  const rules = [];

  // Financial Rules - available to all users with finance permission
  rules.push({
    category: NOTIFICATION_RULE_CATEGORIES.FINANCIAL,
    title: 'Financial Rules',
    color: 'green',
    items: [
      'Overdue A/R Alerts',
      'Low Profitability Alerts',
      ...(userRole === 'admin' ? ['Cash Runway Alerts'] : [])
    ]
  });

  // Operational Rules - available to users with client permission
  rules.push({
    category: NOTIFICATION_RULE_CATEGORIES.OPERATIONAL,
    title: 'Operational Rules',
    color: 'purple',
    items: [
      'Client Overservicing',
      'Billing Cycle Issues',
      'Missing Time Entries'
    ]
  });

  // Team Rules - available to admins and managers
  if (userRole === 'admin' || userRole === 'manager') {
    rules.push({
      category: NOTIFICATION_RULE_CATEGORIES.TEAM,
      title: 'Team Rules',
      color: 'indigo',
      items: [
        'Low Utilization Alerts',
        'Rate Change Notifications'
      ]
    });
  }

  return rules;
};
